export default {
    isAuthenticated: state => {
        return state.isAuthenticated;
    },
    getMessageByUid: state => uid => {
        return state.messages.find(message => message.uid === uid);
    },
    getMessageGroupByUid: state => uid => {
        return state.messageGroups.find(
            messageGroup => messageGroup.uid === uid
        );
    },
    getEmployeeByUid: state => uid => {
        return state.employees.find(employee => employee.uid === uid);
    },
    getEmployeeByFbUid: state => fbUid => {
        return state.employees.find(employee => employee.fbUid === fbUid);
    }
};
